export const translation = {
  nav: {
    home: 'Accueil',
    guides: 'Guides',
    categories: 'Catégories',
    article: 'Article',
    shoppingGuide: 'Guide d\'Achat',
    explore: 'Explorer le Spreadsheet',
    buyNow: 'Acheter Maintenant',
  },
  hero: {
    eyebrow: 'LE HUB DE RESSOURCES ALLCHINABUY',
    headline: 'AllChinaBuy Spreadsheet — Trouvez des Produits, Vendeurs & Guides d\'Achat en Un Seul Endroit',
    subheadline: 'Explorez les ressources organisées du spreadsheet AllChinaBuy, les catégories de produits, les guides de vendeurs de confiance, les informations QC, les coûts d\'expédition, les conseils d\'entrepôt, les avis et les guides d\'achat pratiques avant d\'acheter.',
    ctaExplore: 'Explorer le Spreadsheet AllChinaBuy',
    ctaBrowse: 'Parcourir les Guides d\'Achat',
    trustLine: 'Ressource Indépendante • Guides Pratiques • Contenu Mis à Jour',
  },
  whatIs: {
    h2: 'Qu\'est-ce que le Spreadsheet AllChinaBuy ?',
    copy: 'Le Spreadsheet AllChinaBuy est une ressource structurée qui facilite la découverte de produits. Explorez les produits, catégories, vendeurs, informations QC, ressources d\'expédition et guides d\'achat depuis un emplacement organisé.',
  },
  everythingNeed: {
    h2: 'Tout Ce Dont Vous Avez Besoin pour Rechercher des Produits AllChinaBuy',
    cards: {
      productDiscovery: 'Découverte de Produits',
      productDiscoveryDesc: 'Explorez les ressources de produits et catégories organisées.',
      sellerResearch: 'Recherche de Vendeurs',
      sellerResearchDesc: 'Comparez les informations des vendeurs et les considérations d\'achat.',
      qcInfo: 'Informations QC',
      qcInfoDesc: 'Comprenez les photos de contrôle qualité et leurs limites.',
      shippingGuides: 'Guides d\'Expédition',
      shippingGuidesDesc: 'Apprenez les méthodes d\'expédition, les coûts et les questions courantes.',
    },
  },
  popularResources: {
    h2: 'Ressources AllChinaBuy Populaires',
    spreadsheet: 'Spreadsheet AllChinaBuy',
    review: 'Avis AllChinaBuy',
    shippingCost: 'Coût d\'Expédition AllChinaBuy',
    warehouse: 'Entrepôt AllChinaBuy',
    coupon: 'Coupon AllChinaBuy',
    discountCode: 'Code de Réduction AllChinaBuy',
    legit: 'AllChinaBuy Légitime',
    qc: 'QC AllChinaBuy',
    trustedSellers: 'Vendeurs de Confiance',
    buyingGuides: 'Guides d\'Achat',
  },
  productCategories: {
    h2: 'Explorez les Catégories de Produits AllChinaBuy',
    shoes: 'Chaussures',
    hoodiesSweaters: 'Sweats/Pulls',
    tShirts: 'T-Shirts',
    jackets: 'Vestes',
    pantsShorts: 'Pantalons/Shorts',
    headwear: 'Couvre-Chefs',
    sets: 'Ensembles',
    underwear: 'Sous-Vêtements',
    jersey: 'Maillots',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    otherStuff: 'Autres Articles',
  },
  howToUse: {
    h2: 'Comment Utiliser le Spreadsheet AllChinaBuy',
    steps: {
      step1: 'Choisissez une catégorie.',
      step2: 'Recherchez des produits et vendeurs.',
      step3: 'Comparez les options.',
      step4: 'Consultez les informations QC.',
      step5: 'Vérifiez les informations d\'entrepôt et d\'expédition.',
      step6: 'Prenez une décision éclairée.',
    },
    cta: 'Commencer à Explorer le Spreadsheet',
  },
  researchFirst: {
    h2: 'Recherchez D\'abord. Achetez en Toute Confiance.',
    copy: 'Comprendre la recherche de vendeurs, les informations sur les produits, les processus QC, les options d\'expédition et les risques d\'achat vous aide à prendre des décisions plus intelligentes. Nos guides vous accompagnent à chaque étape du processus de recherche.',
  },
  stayInformed: {
    h2: 'Restez Informé Avant d\'Acheter',
    copy: 'Vérifiez toujours les informations sur les produits, les détails des vendeurs, les informations de paiement, les conditions d\'expédition et les URLs. Aucun spreadsheet ne peut garantir la qualité, l\'authenticité ou les résultats de transaction.',
    cta: 'Lire le Guide de Sécurité',
  },
  readyToExplore: {
    h2: 'Prêt à Explorer AllChinaBuy ?',
    copy: 'Commencez avec le Spreadsheet AllChinaBuy, comparez les produits et vendeurs, apprenez le QC et l\'expédition, et utilisez nos guides d\'achat pour prendre des décisions mieux informées.',
    ctaExplore: 'Explorer le Spreadsheet AllChinaBuy',
    ctaVisit: 'Visiter le Site Principal',
  },
  footer: {
    disclaimer: 'Ce site web est une ressource d\'information indépendante. Les informations peuvent changer et doivent être vérifiées indépendamment avant l\'achat.',
    copyright: '© 2026 AllChinaBuy Spreadsheet. Tous droits réservés.',
    links: {
      home: 'Accueil',
      guides: 'Guides',
      safety: 'Sécurité',
      contact: 'Contact',
    },
  },
  categories: {
    shoes: 'Chaussures',
    hoodiesSweaters: 'Sweats/Pulls',
    tShirts: 'T-Shirts',
    jackets: 'Vestes',
    pantsShorts: 'Pantalons/Shorts',
    headwear: 'Couvre-Chefs',
    sets: 'Ensembles',
    underwear: 'Sous-Vêtements',
    jersey: 'Maillots',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    otherStuff: 'Autres Articles',
  },
  pillarArticles: {
    h2: 'Guides Piliers & Ressources',
  },
  article: {
    readMore: 'Lire la Suite',
    relatedArticles: 'Articles Connexes',
    backToHome: 'Retour à l\'Accueil',
  },
};